export const shared = {
  privacyTermsNotification: 'privacyPolicy_notificationBanner_frontend', // Note: traffic type is consumer-anon
  maintenanceNotificationBanner: 'maintenance_notificationBanner_web',
} as const;
